var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3736 2.1229C15.5453 2.1229 14.7507 2.45864 14.1649 3.05627L4.60354 12.811C3.62732 13.807 3.07887 15.1578 3.07887 16.5664C3.07887 17.9748 3.62732 19.3256 4.60354 20.3216C5.57977 21.3175 6.90382 21.8771 8.28441 21.8771C9.66501 21.8771 10.9891 21.3175 11.9653 20.3216L21.5266 10.5669L22.9981 12.068L13.4366 21.8227C12.0702 23.2168 10.2169 24 8.28441 24C6.35194 24 4.49863 23.2168 3.13217 21.8227C1.76571 20.4287 0.998047 18.5378 0.998047 16.5664C0.998047 14.5948 1.76571 12.7039 3.13217 11.3099L12.6936 1.55515C13.6695 0.559404 14.9934 0 16.3736 0C17.7539 0 19.0777 0.559404 20.0536 1.55515C21.0297 2.5509 21.578 3.90142 21.578 5.30962C21.578 6.71782 21.0297 8.06833 20.0536 9.06408L10.4819 18.8188C9.89631 19.4162 9.10211 19.7519 8.27401 19.7519C7.4459 19.7519 6.6517 19.4162 6.06614 18.8188C5.48057 18.2214 5.15161 17.4112 5.15161 16.5664C5.15161 15.7214 5.48057 14.9112 6.06614 14.3138L14.8997 5.31224L16.3701 6.81425L7.53751 15.8149C7.34245 16.0141 7.23244 16.2847 7.23244 16.5664C7.23244 16.8481 7.34217 17.1184 7.53751 17.3177C7.73284 17.517 7.99777 17.629 8.27401 17.629C8.55025 17.629 8.81517 17.517 9.01051 17.3177L18.5823 7.56296C19.1678 6.96538 19.4972 6.1546 19.4972 5.30962C19.4972 4.46444 19.1681 3.65389 18.5823 3.05627C17.9965 2.45864 17.2021 2.1229 16.3736 2.1229Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.abdd02f81af21f848fb738cb47c57097.svg";
export { ForwardRef as ReactComponent };